// extracted by mini-css-extract-plugin
export default {"policyText":"TermsAndCondition_policyText__v81ze","serviceText":"TermsAndCondition_serviceText__nPaKy","link":"TermsAndCondition_link__FCfwY"};